import PouchDB from "pouchdb"

import find from 'pouchdb-find';
import rel from 'relational-pouch';
import PouchUpsert from "pouchdb-upsert"

export default PouchDB
    .plugin(find)
    .plugin(rel)
    .plugin(PouchUpsert)



